<template>
  <ESelect
    :value="fieldValue"
    class="search-select"
    v-bind="{...$attrs, ...$props}"
    :options="autosuggest ? options : filteredOptions"
    searchable
    :type-ahead="false"
    :mobile-native="false"
    @search="onSearch"
    @input="input"
    @close="$emit('close')"
    @open="$emit('open')"
  >
    <template #list-item="slotProps">
      <slot name="list-item" :option="slotProps.option">
        {{ slotProps.option.label }}
      </slot>
    </template>
  </ESelect>
</template>

<script>
import ESelect from './index';

export default {
  name: 'ESearchSelect',
  components: {
    ESelect,
  },
  props: {
    /**
     * The list of options in the select.
     * Format: String[] or {value: String, label: String}[]
     */
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    /**
     * If true, the options filtering is external,
     * and the event 'search' should be listened to.
     */
    autosuggest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchTerm: '',
      fieldValue: this.value,
      filteredOptions: this.options,
    };
  },
  watch: {
    value(val) {
      this.fieldValue = val;
    },
  },
  methods: {
    /**
     * @param {string} searchTerm
     */
    onSearch(searchTerm) {
      this.$emit('search', searchTerm);
      this.searchTerm = searchTerm;
      if (!this.autosuggest) {
        this.filteredOptions = this.defaultFilterFunction(this.searchTerm);
      }
    },
    defaultFilterFunction(searchTerm) {
      return this.options.filter((option) => {
        const label = option.label || option;
        return label.toLowerCase().includes(searchTerm.toLowerCase());
      });
    },
    input(value) {
      this.$emit('input', value);
    },
  },
};
</script>
